<script setup lang="ts">

import { RowSlot } from '@shared/ui/other'
import { LinkTextPrimaryMedium } from '@shared/ui/links'

import { useMainInfoTutor } from '../../model/use-main-info-tutor.hook'

defineOptions({
  name: 'MainInfoTutor',
})

const {
  refHref,
  refLabel,
} = useMainInfoTutor()
</script>

<template>
  <RowSlot label="Tutor">
    <LinkTextPrimaryMedium
      :href="refHref"
      target="_blank"
    >
      {{ refLabel }}
    </LinkTextPrimaryMedium>
  </RowSlot>
</template>
